/**
 * Retrieves the selected Map Places search result.
 *
 * @param {Object} state
 * @returns {Object}
 */
export function selectedExternalAddress(state) {
  return state.mapPlacesSearchResults[state.selectedExternalAddressIndex];
}

/**
 * Returns a processed version of filterTerms for use in table filtering
 *
 * @param {Object} state
 * @returns {Object[]}
 */
export function processedFilterTerms(state) {
  const { filterTerms = '' } = state;
  return filterTerms
    .toLowerCase()
    .split(',')
    .map((term) => term.trim())
    .filter((term) => term.length);
}
